export const SET_NOTIF = 'states/notif/SET_NOTIF';
export const CLEAR_NOTIF = 'states/notif/CLEAR_NOTIF';